module.exports = __webpack_public_path__ + "img/bg_icon_03.248fbb5a.svg";